import Form from "@/common/components/form/Form";
import { states } from "@/common/data";
import { useMemo } from "react";

export interface UserAddressProps {
  setAddressData: React.Dispatch<React.SetStateAction<any>>;
}

const UserAddress = ({ setAddressData }: UserAddressProps) => {
  const addressFormData = useMemo(
    () => [
      {
        inputType: "selectParent",
        prompt: "State",
        name: "state",
        placeholder: "Select your state",
        fullWidth: false,
        options: states,
        rules: {
          minLength: {
            expectedValue: 1,
            errorMessage: "State must be selected",
          },
        },
      },
      {
        inputType: "selectChild",
        prompt: "Local Government Area",
        name: "lga",
        placeholder: "Select your LGA",
        fullWidth: false,
        options: states,
        parentName: "state",
        rules: {
          minLength: {
            expectedValue: 1,
            errorMessage: "Lga must be selected",
          },
        },
      },
      {
        inputType: "input",
        prompt: "City",
        name: "city",
        placeholder: "Enter your city",
        fullWidth: false,
        rules: {
          minLength: {
            expectedValue: 2,
            errorMessage: "City must be at least 2 characters long",
          },
        },
      },
      {
        inputType: "input",
        prompt: "Street",
        name: "street",
        placeholder: "Enter your street",
        fullWidth: false,
        rules: {
          minLength: {
            expectedValue: 2,
            errorMessage: "Street must be at least 2 characters long",
          },
        },
      },
      {
        inputType: "input",
        prompt: "Building number",
        name: "building_number",
        placeholder: "Enter your building number",
        fullWidth: false,
        rules: {
          minLength: {
            expectedValue: 2,
            errorMessage: "Building number must be at least 2 characters long",
          },
        },
      },
      {
        inputType: "input",
        prompt: "Postal code",
        name: "postal_code",
        placeholder: "Enter your postal code",
        fullWidth: false,
        rules: {
          minLength: {
            expectedValue: 2,
            errorMessage: "Postal code must be at least 2 characters long",
          },
        },
      },
      {
        inputType: "input",
        prompt: "Landmark",
        name: "landmark",
        placeholder: "Enter your landmark",
        fullWidth: false,
        rules: {
          minLength: {
            expectedValue: 2,
            errorMessage: "Landmark must be at least 2 characters long",
          },
        },
      },
    ],
    [],
  );
  return (
    <div>
      <div className="input_container">
        <div className="heading">MEDEX Onboarding</div>
        <div className="sub-heading">
          <div className="stepcounter">Step 4 of 5</div>
          <div className="stepcountTitle">Address Information</div>
        </div>
      </div>
      <Form
        formInputs={addressFormData}
        processInputs={() => {}}
        removeSubmitButton
        externalUpdateData={(name, value) => {
          console.log(name, value);
          setAddressData((prev: any) => ({ ...prev, [name]: value }));
        }}
      />
    </div>
  );
};

export default UserAddress;
